import { useField, useFormikContext } from 'formik';

import { Switch } from '../../InputFields';

interface FormikSwitchProps {
  name: string;
  label: string | { on: string; off: string };
  disabled?: boolean | string;
  onChange?: (checked: boolean) => void;
}

export const FormikSwitch = ({
  name,
  label,
  disabled = false,
  onChange: propOnChange,
}: FormikSwitchProps) => {
  const [field, , helpers] = useField(name);
  const { values } = useFormikContext<Record<string, unknown>>();
  const isDisabled = typeof disabled === 'string' ? !values[disabled] : disabled;

  const handleChange = (checked: boolean) => {
    helpers.setValue(checked);
    helpers.setTouched(true);
    if (propOnChange) {
      propOnChange(checked);
    }
  };

  return (
    <Switch
      id={field.name}
      name={field.name}
      checked={field.value as boolean}
      onChange={handleChange}
      onBlur={field.onBlur}
      label={label}
      disabled={isDisabled}
    />
  );
};
